// data.js - UpSet Plot Data for All Industries

export const upsetData = {
  "All Industries": {
    "total_accounts": 4002,
    "sets": [
        {
            "name": "AmEx",
            "size": 224
        },
        {
            "name": "Copiers",
            "size": 588
        },
        {
            "name": "Facilities",
            "size": 285
        },
        {
            "name": "Hospitality",
            "size": 258
        },
        {
            "name": "Human Resources",
            "size": 722
        },
        {
            "name": "IT Products and Services",
            "size": 1425
        },
        {
            "name": "Logistics",
            "size": 147
        },
        {
            "name": "Material Handling",
            "size": 310
        },
        {
            "name": "Office Supplies",
            "size": 2276
        },
        {
            "name": "PBM",
            "size": 393
        },
        {
            "name": "Rental Car",
            "size": 2125
        },
        {
            "name": "Small Parcel",
            "size": 2064
        },
        {
            "name": "Travel",
            "size": 946
        }
    ],
    "intersections": [
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 335
        },
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 300
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 166
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 134
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 127
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 120
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 93
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 92
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 90
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 79
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 77
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 71
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 66
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 54
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 50
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 48
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 48
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 45
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 42
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 41
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 39
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 36
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 35
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 33
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 29
        },
        {
            "sets": [
                "Travel"
            ],
            "size": 28
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 26
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 24
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 23
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 21
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 20
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 19
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 19
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 18
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 18
        },
        {
            "sets": [
                "Material Handling"
            ],
            "size": 17
        },
        {
            "sets": [
                "Copiers"
            ],
            "size": 16
        },
        {
            "sets": [
                "Logistics"
            ],
            "size": 16
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 15
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 15
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Small Parcel"
            ],
            "size": 14
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 14
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 14
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 13
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 13
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 12
        },
        {
            "sets": [
                "Logistics",
                "Small Parcel"
            ],
            "size": 12
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 12
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 12
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 11
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 11
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 11
        },
        {
            "sets": [
                "Material Handling",
                "Small Parcel"
            ],
            "size": 11
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 10
        },
        {
            "sets": [
                "Copiers",
                "Small Parcel"
            ],
            "size": 10
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 10
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 9
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies"
            ],
            "size": 9
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 9
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 9
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 9
        },
        {
            "sets": [
                "IT Products and Services",
                "Travel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 9
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car"
            ],
            "size": 9
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Copiers",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 8
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "AmEx",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 7
        },
        {
            "sets": [
                "Hospitality"
            ],
            "size": 7
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Human Resources",
                "PBM"
            ],
            "size": 7
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services"
            ],
            "size": 5
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Facilities"
            ],
            "size": 5
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies"
            ],
            "size": 5
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "PBM",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "AmEx",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies"
            ],
            "size": 4
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Logistics",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Office Supplies",
                "PBM"
            ],
            "size": 4
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Hospitality",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "PBM",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Logistics",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Logistics",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Logistics",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Logistics",
                "Material Handling",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Logistics",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Travel"
            ],
            "size": 1
        }
    ],
  
},
 "Construction":{
    "total_accounts": 148,
    "sets": [
        {
            "name": "AmEx",
            "size": 4
        },
        {
            "name": "Copiers",
            "size": 21
        },
        {
            "name": "Facilities",
            "size": 16
        },
        {
            "name": "Hospitality",
            "size": 4
        },
        {
            "name": "Human Resources",
            "size": 24
        },
        {
            "name": "IT Products and Services",
            "size": 56
        },
        {
            "name": "Logistics",
            "size": 6
        },
        {
            "name": "Material Handling",
            "size": 9
        },
        {
            "name": "Office Supplies",
            "size": 93
        },
        {
            "name": "PBM",
            "size": 24
        },
        {
            "name": "Rental Car",
            "size": 79
        },
        {
            "name": "Small Parcel",
            "size": 60
        },
        {
            "name": "Travel",
            "size": 44
        }
    ],
    "intersections": [
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 22
        },
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 5
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Facilities"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        }
    ],
},
"Retail": {
    "total_accounts": 375,
    "sets": [
        {
            "name": "AmEx",
            "size": 11
        },
        {
            "name": "Copiers",
            "size": 45
        },
        {
            "name": "Facilities",
            "size": 36
        },
        {
            "name": "Hospitality",
            "size": 22
        },
        {
            "name": "Human Resources",
            "size": 59
        },
        {
            "name": "IT Products and Services",
            "size": 127
        },
        {
            "name": "Logistics",
            "size": 20
        },
        {
            "name": "Material Handling",
            "size": 53
        },
        {
            "name": "Office Supplies",
            "size": 190
        },
        {
            "name": "PBM",
            "size": 21
        },
        {
            "name": "Rental Car",
            "size": 184
        },
        {
            "name": "Small Parcel",
            "size": 187
        },
        {
            "name": "Travel",
            "size": 79
        }
    ],
    "intersections": [
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 46
        },
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 24
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 16
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 14
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 9
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 9
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 9
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 6
        },
        {
            "sets": [
                "Logistics"
            ],
            "size": 6
        },
        {
            "sets": [
                "Material Handling",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Logistics",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        }
    ]
},
"Business Services":{
    "total_accounts": 391,
    "sets": [
        {
            "name": "AmEx",
            "size": 21
        },
        {
            "name": "Copiers",
            "size": 62
        },
        {
            "name": "Facilities",
            "size": 19
        },
        {
            "name": "Hospitality",
            "size": 40
        },
        {
            "name": "Human Resources",
            "size": 104
        },
        {
            "name": "IT Products and Services",
            "size": 164
        },
        {
            "name": "Logistics",
            "size": 6
        },
        {
            "name": "Material Handling",
            "size": 14
        },
        {
            "name": "Office Supplies",
            "size": 229
        },
        {
            "name": "PBM",
            "size": 49
        },
        {
            "name": "Rental Car",
            "size": 234
        },
        {
            "name": "Small Parcel",
            "size": 225
        },
        {
            "name": "Travel",
            "size": 109
        }
    ],
    "intersections": [
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 24
        },
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 18
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 14
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 12
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 11
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 11
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 11
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 11
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 10
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 10
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 8
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 7
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        }
    ]
},
 "Manufacturing": {
    "total_accounts": 908,
    "sets": [
        {
            "name": "AmEx",
            "size": 39
        },
        {
            "name": "Copiers",
            "size": 151
        },
        {
            "name": "Facilities",
            "size": 86
        },
        {
            "name": "Hospitality",
            "size": 59
        },
        {
            "name": "Human Resources",
            "size": 145
        },
        {
            "name": "IT Products and Services",
            "size": 356
        },
        {
            "name": "Logistics",
            "size": 67
        },
        {
            "name": "Material Handling",
            "size": 159
        },
        {
            "name": "Office Supplies",
            "size": 554
        },
        {
            "name": "PBM",
            "size": 73
        },
        {
            "name": "Rental Car",
            "size": 529
        },
        {
            "name": "Small Parcel",
            "size": 492
        },
        {
            "name": "Travel",
            "size": 220
        }
    ],
    "intersections": [
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 74
        },
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 56
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 40
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 26
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 25
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 24
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 24
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 23
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 18
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 17
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 14
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 13
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 12
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 11
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 10
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 10
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 9
        },
        {
            "sets": [
                "Material Handling"
            ],
            "size": 9
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 8
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 7
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 7
        },
        {
            "sets": [
                "Copiers"
            ],
            "size": 6
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Logistics"
            ],
            "size": 6
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Material Handling",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies"
            ],
            "size": 3
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Logistics",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Logistics",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Logistics",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Material Handling",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Logistics",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        }
    ], 
},
"Consumer Services": {
    "total_accounts": 201,
    "sets": [
        {
            "name": "AmEx",
            "size": 20
        },
        {
            "name": "Copiers",
            "size": 19
        },
        {
            "name": "Facilities",
            "size": 16
        },
        {
            "name": "Hospitality",
            "size": 7
        },
        {
            "name": "Human Resources",
            "size": 26
        },
        {
            "name": "IT Products and Services",
            "size": 75
        },
        {
            "name": "Logistics",
            "size": 7
        },
        {
            "name": "Material Handling",
            "size": 16
        },
        {
            "name": "Office Supplies",
            "size": 113
        },
        {
            "name": "PBM",
            "size": 13
        },
        {
            "name": "Rental Car",
            "size": 89
        },
        {
            "name": "Small Parcel",
            "size": 77
        },
        {
            "name": "Travel",
            "size": 54
        }
    ],
    "intersections": [
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 26
        },
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 15
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 11
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 7
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 7
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Logistics",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Hospitality",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Logistics",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Material Handling",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        }
    ]
}, 
"Software": {
    "total_accounts": 303,
    "sets": [
        {
            "name": "AmEx",
            "size": 22
        },
        {
            "name": "Copiers",
            "size": 45
        },
        {
            "name": "Facilities",
            "size": 7
        },
        {
            "name": "Hospitality",
            "size": 25
        },
        {
            "name": "Human Resources",
            "size": 81
        },
        {
            "name": "IT Products and Services",
            "size": 116
        },
        {
            "name": "Logistics",
            "size": 3
        },
        {
            "name": "Material Handling",
            "size": 4
        },
        {
            "name": "Office Supplies",
            "size": 163
        },
        {
            "name": "PBM",
            "size": 28
        },
        {
            "name": "Rental Car",
            "size": 194
        },
        {
            "name": "Small Parcel",
            "size": 205
        },
        {
            "name": "Travel",
            "size": 77
        }
    ],
    "intersections": [
        {
            "sets": [
                "Small Parcel"
            ],
            "size": 20
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 16
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel"
            ],
            "size": 14
        },
        {
            "sets": [
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 13
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 10
        },
        {
            "sets": [
                "IT Products and Services"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 8
        },
        {
            "sets": [
                "Rental Car"
            ],
            "size": 8
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 6
        },
        {
            "sets": [
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 6
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car"
            ],
            "size": 5
        },
        {
            "sets": [
                "Rental Car",
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Travel"
            ],
            "size": 5
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies"
            ],
            "size": 4
        },
        {
            "sets": [
                "Human Resources",
                "Small Parcel"
            ],
            "size": 4
        },
        {
            "sets": [
                "Office Supplies"
            ],
            "size": 4
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car"
            ],
            "size": 4
        },
        {
            "sets": [
                "AmEx"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 3
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "PBM"
            ],
            "size": 3
        },
        {
            "sets": [
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 3
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Copiers",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 2
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 2
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "Facilities",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Human Resources",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "AmEx",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Hospitality",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "Human Resources",
                "Material Handling",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Human Resources",
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "IT Products and Services",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Copiers",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Facilities",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Human Resources",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Office Supplies",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Hospitality",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Material Handling",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "IT Products and Services",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Office Supplies",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Rental Car",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Human Resources",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Office Supplies",
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "IT Products and Services",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Logistics",
                "Office Supplies",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Rental Car",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "PBM",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Rental Car",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Office Supplies",
                "Travel"
            ],
            "size": 1
        },
        {
            "sets": [
                "PBM",
                "Small Parcel"
            ],
            "size": 1
        },
        {
            "sets": [
                "Small Parcel",
                "Travel"
            ],
            "size": 1
        }
    ]
}
};

// Helper function to get data by industry
export const getUpsetDataByIndustry = (industry) => {
  return upsetData[industry] || upsetData["All Industries"];
};

// Get list of all available industries
export const getIndustries = () => {
  return Object.keys(upsetData);
};